module.exports = __webpack_public_path__ + "static/media/club-logo.876106a8.png";